// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */
.HomeSection-homeSectionBannerBg-pnev9 {
  width: 100%;
  background-position: center;
  background-size: cover;
  padding: 60px 20px;
  background-color: var(--common-gray-bg);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.HomeSection-bannerSectionRow-nxZW9 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 20px;
}
.HomeSection-bannerContentSection-TUETn {
  max-width: 615px;
  width: 100%;
  text-align: start;
}
.HomeSection-bannerImageSection-tAu_k {
  max-width: 538px;
  width: 100%;
}
.HomeSection-bannerImageContainer-TfqTB {
  max-width: 538px;
  height: 496px;
  width: 100%;
  margin: auto;
}
.HomeSection-bannerImageContainer-TfqTB>img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}
.HomeSection-bannerHeading-W7zii {
  font-size: 48px;
  line-height: 58px;
  font-weight: 700;
  color: var(--common-primary-foreground);
  margin-top: 0;
  margin-bottom: 18px;
}
.HomeSection-homeBannerPara-FlkYr {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  color: var(--common-primary-foreground);
  margin-bottom: 36px;
}
.HomeSection-homeBannerSpecialText-igZ4G {
  color: var(--primary-bg);
}
@media (min-width:1200px) {
  .HomeSection-homeSectionBannerBg-pnev9 {
    min-height: 630px;
  }
}
@media (max-width: 1199px) and (min-width: 768px) {
  .HomeSection-bannerHeading-W7zii {
    font-size: 38px;
    line-height: 48px;
  }
}
@media (max-width:991px) {
  .HomeSection-homeSectionBannerBg-pnev9 {
    padding: 36px 0;
  }

  .HomeSection-bannerSectionRow-nxZW9 {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .HomeSection-bannerImageSection-tAu_k,
  .HomeSection-bannerContentSection-TUETn {
    max-width: 100%;
  }

  .HomeSection-bannerImageContainer-TfqTB {
    height: 400px;
  }
}
@media (max-width:767px) {
  .HomeSection-bannerHeading-W7zii {
    font-size: 28px;
    line-height: 38px;
  }

  .HomeSection-bannerImageContainer-TfqTB {
    max-width: 291px;
    height: 269px;
    margin-right: auto;
  }

  .HomeSection-homeBannerPara-FlkYr {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeSection/HomeSection.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;EACE,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;AACrB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAe;QAAf,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":["/* new */\n.homeSectionBannerBg {\n  width: 100%;\n  background-position: center;\n  background-size: cover;\n  padding: 60px 20px;\n  background-color: var(--common-gray-bg);\n  display: flex;\n  align-items: center;\n}\n\n.bannerSectionRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.bannerContentSection {\n  max-width: 615px;\n  width: 100%;\n  text-align: start;\n}\n\n.bannerImageSection {\n  max-width: 538px;\n  width: 100%;\n}\n\n.bannerImageContainer {\n  max-width: 538px;\n  height: 496px;\n  width: 100%;\n  margin: auto;\n}\n\n.bannerImageContainer>img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.bannerHeading {\n  font-size: 48px;\n  line-height: 58px;\n  font-weight: 700;\n  color: var(--common-primary-foreground);\n  margin-top: 0;\n  margin-bottom: 18px;\n}\n\n.homeBannerPara {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 28px;\n  color: var(--common-primary-foreground);\n  margin-bottom: 36px;\n}\n\n.homeBannerSpecialText {\n  color: var(--primary-bg);\n}\n\n@media (min-width:1200px) {\n  .homeSectionBannerBg {\n    min-height: 630px;\n  }\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n  .bannerHeading {\n    font-size: 38px;\n    line-height: 48px;\n  }\n}\n\n@media (max-width:991px) {\n  .homeSectionBannerBg {\n    padding: 36px 0;\n  }\n\n  .bannerSectionRow {\n    flex-wrap: wrap;\n  }\n\n  .bannerImageSection,\n  .bannerContentSection {\n    max-width: 100%;\n  }\n\n  .bannerImageContainer {\n    height: 400px;\n  }\n}\n\n@media (max-width:767px) {\n  .bannerHeading {\n    font-size: 28px;\n    line-height: 38px;\n  }\n\n  .bannerImageContainer {\n    max-width: 291px;\n    height: 269px;\n    margin-right: auto;\n  }\n\n  .homeBannerPara {\n    font-size: 16px;\n    line-height: 26px;\n    margin-bottom: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeSectionBannerBg": `HomeSection-homeSectionBannerBg-pnev9`,
	"bannerSectionRow": `HomeSection-bannerSectionRow-nxZW9`,
	"bannerContentSection": `HomeSection-bannerContentSection-TUETn`,
	"bannerImageSection": `HomeSection-bannerImageSection-tAu_k`,
	"bannerImageContainer": `HomeSection-bannerImageContainer-TfqTB`,
	"bannerHeading": `HomeSection-bannerHeading-W7zii`,
	"homeBannerPara": `HomeSection-homeBannerPara-FlkYr`,
	"homeBannerSpecialText": `HomeSection-homeBannerSpecialText-igZ4G`
};
module.exports = ___CSS_LOADER_EXPORT___;
